
const newModel = () => {
    return {
        hinhthuckinhdoanhCosoduocId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        hinhthuckinhdoanhCosoduocId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        hinhthuckinhdoanhCosoduocId: item.hinhthuckinhdoanhCosoduocId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        hinhthuckinhdoanhCosoduocId: item.hinhthuckinhdoanhCosoduocId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        hinhthuckinhdoanhCosoduocId: null,
        ten: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        hinhthuckinhdoanhCosoduocId: item.hinhthuckinhdoanhCosoduocId,
        ten: item.ten,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        hinhthuckinhdoanhCosoduocId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const hinhThucKinhDoanhCoSoDuocModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


